<template>
  <div class="organ">
    <div class="orgTop">党组织情况</div>
    <div class="orgCenter">
      <div class="orgLeft">
        <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
          <el-menu :default-openeds="['1', '3']">
            <el-submenu index="1">
              <template slot="title">导航一</template>
              <el-menu-item-group>
                <template slot="title">分组一</template>
              </el-menu-item-group>
              <!-- <el-menu-item-group title="分组2">
    
              </el-menu-item-group>
              <el-submenu index="1-4">
                <template slot="title">选项4</template>
                <el-menu-item index="1-4-1">选项4-1</el-menu-item>
              </el-submenu>-->
            </el-submenu>
            <el-submenu index="2">
              <template slot="title">导航二</template>
              <el-menu-item-group>
                <template slot="title">分组一</template>
                <!-- <el-menu-item index="2-1">选项1</el-menu-item>
                <el-menu-item index="2-2">选项2</el-menu-item>-->
              </el-menu-item-group>
              <el-menu-item-group title="分组2">
                <el-menu-item index="2-3">选项3</el-menu-item>
              </el-menu-item-group>
              <!-- <el-submenu index="2-4">
                <template slot="title">选项4</template>
                <el-menu-item index="2-4-1">选项4-1</el-menu-item>
              </el-submenu>-->
            </el-submenu>
            <el-submenu index="3">
              <template slot="title">导航三</template>
              <el-menu-item-group>
                <template slot="title">分组一</template>
                <!-- <el-menu-item index="3-1">选项1</el-menu-item>
                <el-menu-item index="3-2">选项2</el-menu-item>-->
              </el-menu-item-group>
              <el-menu-item-group title="分组2">
                <!-- <el-menu-item index="3-3">选项3</el-menu-item> -->
              </el-menu-item-group>
              <!-- <el-submenu index="3-4">
                <template slot="title">选项4</template>
                <el-menu-item index="3-4-1">选项4-1</el-menu-item>
              </el-submenu>-->
            </el-submenu>
          </el-menu>
        </el-aside>
      </div>
      <div class="orgRight">
        <div class="orgRightop">
          <div class="orgList" v-for="(item,index) in orgList" :key='index'>
            <div class="orgLtitle">杭州市凯旋街道社区第一支部委员会</div>
            <div class="orgMess">
              <div class="per">
                <img src="../../assets/images/pers.png" alt /> 社区党组织负责人： 陈某某
              </div>

              <div class="per">
                <img src="../../assets/images/tel.png" alt />联系电话： 0532-88888888
              </div>

              <div class="per">
                <img src="../../assets/images/gov.png" alt />党组织类别： 支部委员会
              </div>
            </div>
          </div>
        </div>

       <Pagination
        :total="total"
        @pagination="fetchData"
      />

      </div>
    </div>
  </div>
</template>
<script>
import Pagination from '@/components/pagination'
export default {
  name: "",
  components: {
    Pagination
  },

  data() {
    return{
currentPage:0,
total:10,
searchForm:{
  pageSize:1
},
input:'',
value:'',
orgList:[{},{},{}],
options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
    }
  },
  created(){
      console.log('jinlai')
  },
    methods: {
            fetchData(e){
      console.log(e)
    },
    handleCurrentChange(cpage) {
    this.currentPage= cpage||9;
},
jumpFirstPage () {
    this.$refs.pagination.handleCurrentChange(1);
    this.$emit('handleCurrentChange', 1);
},
jumpLastPage () {
    let font = this.$refs.pagination
    let cpage = Math.ceil(font.total / font.pageSize);
    font.handleCurrentChange(cpage);
}
    }
  }
</script>
<style lang="less" scoped>
.organ {
  height: 1080px;
  background: url("../../assets/images/bg.jpg") no-repeat center/100% 100%;
}
.orgTop {
  text-align: center;
  height: 88px;
  line-height: 88px;
  font-size: 32px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  opacity: 0.91;
  background: url("../../assets/images/orgTop.png") no-repeat center/100% 100%;
}
.orgCenter {
  display: flex;
  flex-direction: row;
}
.orgItext {
  display: flex;
  flex-direction: row;
  .oText {
    width: 24%;
  }
}
.orgLeft {
  margin-left: 30px;
  margin-top: 10px;
  /deep/.el-aside {
    background-color: transparent !important;
  }
}
/deep/.el-menu {
  background-color: transparent !important;
}
.el-menu {
  width: 200px;
  height: 909px;
  background: url("../../assets/images/orgLeft.png") no-repeat center/100% 100%;

  .el-submenu {
    /deep/ .el-submenu__title {
      width: 198px;
      height: 90px;
      background: url("../../assets/images/orgLeft1.png") no-repeat center/100%
        100%;
      font-size: 28px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      padding: 0;
      text-align: center;
      line-height: 90px;
      opacity: 0.5;
    }
    /deep/ .el-submenu__title:hover {
      opacity: 1;
    }
    /deep/ .el-menu-item-group__title:hover {
      background: url("../../assets/images/orgLeft2.png") no-repeat center/100%;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      height: 57px;
      line-height: 57px;
      text-align: center;
    }
    /deep/.el-menu-item-group__title {
      height: 57px;
      line-height: 57px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      opacity: 0.6;
      padding-left: 0 !important;
      text-align: center;
    }
    /deep/.el-menu-item-group__title:hover {
      opacity: 1;
    }
  }
}
.orgRight {
  background: url("../../assets/images/orgCenter.png") no-repeat center/100%;
  width: 1630px;
  height: 909px;
  position: relative;
  .orgList {
      margin-left: 20PX;
      margin-bottom: 25PX;
    background: url("../../assets/images/orgList.png") no-repeat center/100%;
    width: 1594px;
    height: 184px;
    .orgLtitle {
      height: 34px;
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      height: 113px;
      line-height: 113px;
      padding-left: 32PX;
    }
    .orgMess {
      display: flex;
      flex-direction: row;
      padding-left: 32PX;
      height: 71PX;
      img {
        width: 29px;
        height: 29px;
        margin-right: 5PX;
        margin-top: 2PX;
      }
      .per {
        font-size: 28px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        opacity: 0.4;
        height: 34PX;
        line-height: 28PX;
        margin-top: 16PX;
        padding-right: 20PX;
        margin-right: 20PX;
        border-right: 1PX solid #ffffff;
      }
    }
  }
}
</style>
